import React from "react";
import "./dentist.scss";

import drSahaImg from "../../../assets/about/shah.jpeg";
import drSophiaImg from "../../../assets/about/sophia.jpeg";

const Dentist = () => {
  return (
    <section id="dentist" className="ppc-dentist">
      <div className="dentist-container">

        {/* ================= DR. SHANKHADEEP SAHA ================= */}
        <div className="dentist-row">
          <div className="dentist-content">
            <div className="dentist-header">
              <h2>Meet Dr. Shankhadeep Saha</h2>
              <h4>MDS in Periodontics &amp; Implantology</h4>
            </div>

            <div className="dentist-body">
              <p>
                <strong>Dr. Shankhadeep Saha</strong> is a leading dentist in HSR
                Layout with over <strong>9+ years of clinical experience</strong>.
                He completed his BDS from Rajiv Gandhi University of Health Sciences
                and his MDS in Periodontics &amp; Implantology from
                <strong> M. S. Ramaiah University of Applied Sciences</strong>.
              </p>

              <p>
                He specializes in
                <strong>
                  {" "}
                  dental implants, laser dentistry, full mouth rehabilitation,
                  smile designing, and cortico-basal implantology
                </strong>.
              </p>

              <p>
                Dr. Saha is known for restoring both
                <strong> function and aesthetics</strong> with long-term success.
              </p>
            </div>
          </div>

          <div className="dentist-image">
            <img
              src={drSahaImg}
              alt="Dr. Shankhadeep Saha - Dentist in HSR Layout"
              loading="lazy"
            />
          </div>
        </div>

        {/* ================= DR. SOPHIA SAUD ================= */}
        <div className="dentist-row reverse">
          <div className="dentist-content">
            <div className="dentist-header">
              <h2>Dr. Sophia Saud</h2>
              <h4>MDS Endodontist &amp; Aesthetic Specialist</h4>
            </div>

            <div className="dentist-body">
              <p>
                <strong>Dr. Sophia Saud</strong> is a highly skilled Endodontist
                and Aesthetic Specialist in HSR Layout.
              </p>

              <p>
                She specializes in
                <strong>
                  {" "}
                  RCTs, regenerative endodontics, laser dentistry, veneers,
                  and smile designing
                </strong>.
              </p>

              <p>
                Her precision-driven approach ensures accuracy, comfort,
                and patient confidence.
              </p>

              <ul className="dentist-points">
                <li>Endodontist &amp; Aesthetic Specialist (MDS)</li>
                <li>Expert in RCTs, veneers &amp; smile design</li>
                <li>Advanced laser &amp; regenerative procedures</li>
                <li>High-precision, patient-centric care</li>
              </ul>
            </div>
          </div>

          <div className="dentist-image">
            <img
              src={drSophiaImg}
              alt="Dr. Sophia Saud - Endodontist & Aesthetic Specialist"
              loading="lazy"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default Dentist;
